<div class="superbill-setup">
  <h3>SUPERBILL</h3>
  <p class="hint">
    Each code prints on the customer statement. Quantity and price fill in from the frame, lenses, and options on the order.
    The PDF is emailed after the balance is $0.00. The layout is the same for every store. Dispensary code and address come from the store.
  </p>

  <h4>TEMPLATE<span *ngIf="currentStoreName"> · {{ currentStoreName }}</span></h4>
  <div class="template-row">
    <button
      type="button"
      class="thumb-button"
      (click)="openTemplate()"
      [disabled]="!templateBlob"
      aria-label="Open superbill template"
    >
      <canvas #preview width="220" height="284"></canvas>
    </button>
    <div>
      <p class="hint">{{ templateName || 'SUPERBILL TEMPLATE' }}</p>
      <p class="hint" *ngIf="templateUpdated">UPDATED {{ templateUpdated }}</p>
      <button mat-stroked-button type="button" [disabled]="saving" (click)="templateInput.click()">
        UPLOAD TEMPLATE
      </button>
      <input
        #templateInput
        type="file"
        accept="application/pdf,.pdf"
        hidden
        (change)="onTemplateSelected($event)"
      >
    </div>
  </div>

  <h4>STORES</h4>
  <div class="store-card" *ngFor="let store of stores">
    <h5>{{ store.storeName }}</h5>
    <div class="draft-row">
      <mat-form-field>
        <mat-label>DISPENSARY</mat-label>
        <input matInput [(ngModel)]="store.dispensaryName" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>DISPENSARY CODE</mat-label>
        <input matInput [(ngModel)]="store.taxId" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>WEBSITE</mat-label>
        <input matInput [(ngModel)]="store.website" autocomplete="off">
      </mat-form-field>
    </div>
    <div class="draft-row">
      <mat-form-field>
        <mat-label>ADDRESS</mat-label>
        <input matInput [(ngModel)]="store.address" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>ADDRESS 2</mat-label>
        <input matInput [(ngModel)]="store.address2" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>CITY</mat-label>
        <input matInput [(ngModel)]="store.city" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="short">
        <mat-label>STATE</mat-label>
        <input matInput [(ngModel)]="store.state" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="short">
        <mat-label>ZIP</mat-label>
        <input matInput [(ngModel)]="store.zip" autocomplete="off">
      </mat-form-field>
    </div>
    <div class="draft-row">
      <mat-form-field>
        <mat-label>PHONE</mat-label>
        <input matInput [(ngModel)]="store.phone" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>FAX</mat-label>
        <input matInput [(ngModel)]="store.fax" autocomplete="off">
      </mat-form-field>
      <mat-form-field>
        <mat-label>EMAIL</mat-label>
        <input matInput [(ngModel)]="store.email" autocomplete="off">
      </mat-form-field>
      <button mat-raised-button type="button" [disabled]="saving" (click)="saveStore(store)">SAVE STORE</button>
    </div>
  </div>

  <h4>ITEM CODES</h4>
  <div class="draft-row">
    <mat-form-field>
      <mat-label>DESCRIPTION</mat-label>
      <input matInput [(ngModel)]="draft.displayName" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>CPT</mat-label>
      <input matInput [(ngModel)]="draft.insuranceCode" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>APPLIES TO</mat-label>
      <mat-select [(ngModel)]="draft.matchKey">
        <mat-option *ngFor="let match of matchKeys" [value]="match.key">{{ match.label | uppercase }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button type="button" [disabled]="saving" (click)="add()">ADD</button>
  </div>

  <table class="code-table" *ngIf="codes.length">
    <tr>
      <th>DESCRIPTION</th>
      <th>CPT</th>
      <th>APPLIES TO</th>
      <th>ACTIVE</th>
      <th></th>
    </tr>
    <tr *ngFor="let code of codes">
      <td>
        <mat-form-field>
          <input matInput [(ngModel)]="code.displayName">
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <input matInput [(ngModel)]="code.insuranceCode">
        </mat-form-field>
      </td>
      <td>
        <mat-select [(ngModel)]="code.matchKey">
          <mat-option *ngFor="let match of matchKeys" [value]="match.key">{{ match.label | uppercase }}</mat-option>
        </mat-select>
      </td>
      <td>
        <mat-checkbox [(ngModel)]="code.active"></mat-checkbox>
      </td>
      <td class="actions">
        <button mat-button type="button" [disabled]="saving" (click)="saveCode(code)">SAVE</button>
        <button mat-button type="button" (click)="remove(code)">REMOVE</button>
      </td>
    </tr>
  </table>
</div>
